module.exports = function () {
    $('.current-menu-item a').addClass('is-active');

    $('.menu-category-shop-mobile').on('click', function () {
        $('.nav_category').toggleClass("nav_category-mobile-inactive");
        $('.arrow').toggleClass("rotate");
    });

    $('.nav_category>ul>li>a')
        .on('click', function () {
            $('.nav_category>ul>li>a').removeClass('is-active');
            $(this).addClass('is-active');
        })
        // .on('mouseenter', function () {
        //     $('.nav_category>ul>li>a').removeClass('is-active');
        //     $(this).addClass('is-active');
        // })
        // .on('mouseleave', function () {
        //     $('.nav_category>ul>li>a').removeClass('is-active');
        //     $(this).addClass('is-active');
        // })



    $('.products > li').removeClass('first');
    $('.products > li').removeClass('last');

};
